import type { AdminModule, Metric, TableColumn, TableRow } from "../types/domain";

const baseColumns: TableColumn[] = [
  { key: "code", label: "Mã" },
  { key: "name", label: "Đối tượng" },
  { key: "channel", label: "Kênh" },
  { key: "owner", label: "Phụ trách" },
  { key: "status", label: "Trạng thái" },
  { key: "value", label: "Giá trị", align: "right" },
  { key: "updatedAt", label: "Cập nhật" }
];

const operationsRows: TableRow[] = [
  {
    code: "SO-260829-018",
    name: "Bộ điều khiển xe điện 48V-60V",
    channel: "Website",
    owner: "Lan Anh",
    status: "Chờ xác nhận",
    value: "1.455.000đ",
    updatedAt: "08:42"
  },
  {
    code: "MP-TTS-8821",
    name: "Mapping SKU TikTok Shop",
    channel: "TikTok",
    owner: "Minh Quân",
    status: "Cần xử lý",
    value: "12 SKU",
    updatedAt: "08:30"
  },
  {
    code: "PO-CT-0914",
    name: "Nhập sạc lithium 60V",
    channel: "NCC Hưng Phát",
    owner: "Phạm Trúng",
    status: "Đang nhập",
    value: "18.400.000đ",
    updatedAt: "08:14"
  },
  {
    code: "RMA-2209",
    name: "Bảo hành TPMS van trong",
    channel: "Website",
    owner: "Hà My",
    status: "Đang kiểm",
    value: "920.000đ",
    updatedAt: "07:58"
  },
  {
    code: "COD-992",
    name: "Phiên đối soát GHTK",
    channel: "Logistics",
    owner: "Kế toán",
    status: "Lệch 2 dòng",
    value: "22.400.000đ",
    updatedAt: "07:35"
  }
];

const inventoryRows: TableRow[] = [
  {
    code: "SKU-CT-1842",
    name: "Bộ điều khiển 48V-60V",
    channel: "Kho Bình Tân",
    owner: "Kho A",
    status: "Khả dụng",
    value: "36",
    updatedAt: "08:20"
  },
  {
    code: "SKU-CT-2510",
    name: "TPMS van trong",
    channel: "Kho Bình Tân",
    owner: "Kho A",
    status: "Tồn thấp",
    value: "9",
    updatedAt: "08:11"
  },
  {
    code: "SKU-CT-0773",
    name: "Nhớt 10W40 synthetic",
    channel: "Kho Thủ Đức",
    owner: "Kho B",
    status: "Khả dụng",
    value: "120",
    updatedAt: "07:54"
  },
  {
    code: "SKU-CT-3319",
    name: "Dây curoa Vario / Click",
    channel: "Kho Bình Tân",
    owner: "Kho A",
    status: "Đang giữ",
    value: "42",
    updatedAt: "07:40"
  }
];

const peopleRows: TableRow[] = [
  {
    code: "CUS-14028",
    name: "Garage Tân Bình",
    channel: "B2B",
    owner: "Minh Quân",
    status: "Hạn mức tốt",
    value: "42.800.000đ",
    updatedAt: "08:02"
  },
  {
    code: "CUS-11890",
    name: "Nguyễn Văn Hòa",
    channel: "B2C",
    owner: "Lan Anh",
    status: "Đơn mới",
    value: "1.455.000đ",
    updatedAt: "07:55"
  },
  {
    code: "SUP-078",
    name: "NCC Hưng Phát",
    channel: "Supplier",
    owner: "Phạm Trúng",
    status: "PO mở",
    value: "86.200.000đ",
    updatedAt: "07:12"
  }
];

const defaultMetrics: Metric[] = [
  { label: "Doanh thu hôm nay", value: "48,6tr", delta: "+12,8%", tone: "good" },
  { label: "Đơn hôm nay", value: "126", delta: "+9,1%", tone: "good" },
  { label: "Chờ xử lý", value: "18", delta: "Cần xử lý", tone: "warn" },
  { label: "Tồn kho thấp", value: "12 SKU", delta: "Cảnh báo", tone: "danger" },
  { label: "COD chờ đối soát", value: "22,4tr", delta: "4 phiên", tone: "info" }
];

const inventoryMetrics: Metric[] = [
  { label: "Tồn khả dụng", value: "8.426", delta: "+4,2%", tone: "good" },
  { label: "Đang giữ", value: "312", delta: "Theo đơn", tone: "info" },
  { label: "Dưới ngưỡng", value: "12 SKU", delta: "Cần mua", tone: "danger" },
  { label: "Lệch kho", value: "3 SKU", delta: "Kiểm kê", tone: "warn" },
  { label: "Giá trị kho", value: "1,84tỷ", delta: "+2,1%", tone: "good" }
];

const financeMetrics: Metric[] = [
  { label: "Thu hôm nay", value: "48,6tr", delta: "+12,8%", tone: "good" },
  { label: "Chi hôm nay", value: "14,2tr", delta: "PO + vận hành", tone: "warn" },
  { label: "Công nợ NCC", value: "126tr", delta: "7 khoản", tone: "info" },
  { label: "COD chờ về", value: "22,4tr", delta: "4 phiên", tone: "warn" },
  { label: "Lệch đối soát", value: "2 dòng", delta: "Cần khóa", tone: "danger" }
];

const moduleTemplate = (
  id: string,
  title: string,
  description: string,
  rows: TableRow[] = operationsRows,
  metrics: Metric[] = defaultMetrics
): AdminModule => ({
  id,
  title,
  description,
  primaryAction: id.includes("reports") ? "Xuất báo cáo" : "Tạo mới",
  secondaryAction: "Lọc dữ liệu",
  metrics,
  columns: baseColumns,
  rows,
  inspector: [
    { label: "Cảnh báo ưu tiên", value: "2 lỗi đồng bộ", tone: "danger" },
    { label: "SLA gần hạn", value: "18 việc cần xử lý", tone: "warn" },
    { label: "Dữ liệu gần nhất", value: "Đã cập nhật 08:42", tone: "good" }
  ]
});

export const adminModules: Record<string, AdminModule> = {
  dashboard: moduleTemplate(
    "dashboard",
    "Tổng quan",
    "Tình hình vận hành Siêu Thị Ưa Thích theo thời gian thực."
  ),
  orders: moduleTemplate(
    "orders",
    "Đơn hàng",
    "OMS đa kênh: Website, Shopee, TikTok Shop, trạng thái xử lý và bàn giao."
  ),
  products: moduleTemplate(
    "products",
    "Sản phẩm",
    "PIM quản lý SKU, thông số, giá vốn, giá bán, ảnh và mapping kênh.",
    inventoryRows,
    inventoryMetrics
  ),
  inventory: moduleTemplate(
    "inventory",
    "Kho hàng",
    "WMS theo dõi tồn thực, giữ chỗ, khả dụng, cảnh báo và chuyển kho.",
    inventoryRows,
    inventoryMetrics
  ),
  purchasing: moduleTemplate(
    "purchasing",
    "Mua hàng",
    "Procurement quản lý PO, lịch nhập, công nợ và hiệu suất nhà cung cấp."
  ),
  suppliers: moduleTemplate(
    "suppliers",
    "Nhà cung cấp",
    "Supplier master, điều khoản, nhóm hàng, rating và lịch sử PO.",
    peopleRows
  ),
  customers: moduleTemplate(
    "customers",
    "Khách hàng",
    "CRM 360 độ: nhóm khách, doanh số, AOV, tag và chăm sóc lại.",
    peopleRows
  ),
  b2b: moduleTemplate(
    "b2b",
    "B2B / Đại lý",
    "Quản lý dealer, cấp giá, hạn mức công nợ, doanh số và xét duyệt tài khoản.",
    peopleRows
  ),
  marketplaces: moduleTemplate(
    "marketplaces",
    "Marketplace",
    "Kết nối Shopee, TikTok Shop và Website với mapping SKU, sync và lỗi đồng bộ."
  ),
  chat: moduleTemplate(
    "chat",
    "Chat",
    "Omnichannel inbox với hội thoại, khách hàng, đơn hàng và yêu cầu sourcing."
  ),
  finance: moduleTemplate(
    "finance",
    "Tài chính",
    "Finance Ops theo dõi thu chi, công nợ, COD và đối soát.",
    operationsRows,
    financeMetrics
  ),
  reconciliation: moduleTemplate(
    "reconciliation",
    "Đối soát",
    "Đối soát COD, phí sàn, vận chuyển, refund và lệch dòng dữ liệu.",
    operationsRows,
    financeMetrics
  ),
  reports: moduleTemplate(
    "reports",
    "Báo cáo",
    "Analytics doanh thu, AOV, đơn hàng, top SKU, tồn kho và kênh bán."
  ),
  returns: moduleTemplate(
    "returns",
    "Bảo hành / Trả hàng",
    "RMA theo dõi yêu cầu bảo hành, đổi trả, hoàn hàng và kiểm tra kỹ thuật."
  ),
  members: moduleTemplate(
    "members",
    "Thành viên",
    "Quản lý thành viên nội bộ, nhóm quyền, phạm vi kho và trạng thái truy cập.",
    peopleRows
  ),
  roles: moduleTemplate(
    "roles",
    "Vai trò",
    "RBAC theo module, hành động, phạm vi dữ liệu và nhật ký thay đổi quyền.",
    peopleRows
  ),
  audit: moduleTemplate(
    "audit",
    "Nhật ký hệ thống",
    "Audit log theo tác nhân, hành động, đối tượng, nguồn và thời gian."
  ),
  settings: moduleTemplate(
    "settings",
    "Cài đặt & Tích hợp",
    "Cấu hình marketplace, Resend, R2, payment, domain và biến môi trường."
  ),
  integrations: moduleTemplate(
    "integrations",
    "Tích hợp",
    "Trạng thái kết nối Resend, Cloudflare, marketplace, database và webhook."
  ),
  security: moduleTemplate(
    "security",
    "Bảo mật admin",
    "2FA, phiên đăng nhập, chính sách mật khẩu, khóa tài khoản và cảnh báo."
  ),
  profile: moduleTemplate(
    "profile",
    "Hồ sơ admin",
    "Thông tin người vận hành, phân quyền, lịch sử đăng nhập và tùy chọn thông báo.",
    peopleRows
  ),
  notifications: moduleTemplate(
    "notifications",
    "Thông báo",
    "Cảnh báo vận hành, tồn kho, sync, đơn hàng, công nợ và bảo hành."
  ),
  branches: moduleTemplate(
    "branches",
    "Chi nhánh",
    "Quản lý chi nhánh bán hàng, kho liên kết và phạm vi nhân sự.",
    peopleRows
  ),
  warehouses: moduleTemplate(
    "warehouses",
    "Kho & vị trí",
    "Danh sách kho, vị trí, tồn khả dụng, giữ chỗ và kiểm kê.",
    inventoryRows,
    inventoryMetrics
  ),
  "stock-movements": moduleTemplate(
    "stock-movements",
    "Stock ledger",
    "Sổ kho theo nhập, xuất, điều chỉnh, giữ chỗ và rollback.",
    inventoryRows,
    inventoryMetrics
  ),
  "stock-transfer": moduleTemplate(
    "stock-transfer",
    "Chuyển kho",
    "Phiếu chuyển kho, trạng thái bàn giao, nhận hàng và chênh lệch.",
    inventoryRows,
    inventoryMetrics
  ),
  pricing: moduleTemplate(
    "pricing",
    "Bảng giá",
    "Giá bán lẻ, B2B, sàn, khuyến mãi và lịch sử thay đổi."
  ),
  webhooks: moduleTemplate(
    "webhooks",
    "Webhooks",
    "Log webhook marketplace, thanh toán, vận chuyển và retry idempotent."
  ),
  "sync-errors": moduleTemplate(
    "sync-errors",
    "Lỗi đồng bộ",
    "Hàng đợi lỗi sync với nguyên nhân, retry, owner và trạng thái khóa dữ liệu."
  ),
  "order-detail": moduleTemplate(
    "order-detail",
    "Chi tiết đơn admin",
    "Thông tin đơn, sản phẩm, khách, kho, xác nhận và in phiếu."
  ),
  "product-detail": moduleTemplate(
    "product-detail",
    "Chi tiết sản phẩm",
    "Thông số, giá vốn, tồn kho, mapping kênh và trạng thái publish.",
    inventoryRows,
    inventoryMetrics
  ),
  "supplier-detail": moduleTemplate(
    "supplier-detail",
    "Supplier 360°",
    "Hiệu suất nhà cung cấp, điều khoản, công nợ và lịch sử PO.",
    peopleRows
  ),
  "po-detail": moduleTemplate(
    "po-detail",
    "Chi tiết PO",
    "Dòng hàng, giá trị nhập, kho nhận, thanh toán và tạo phiếu nhập."
  ),
  "customer-detail": moduleTemplate(
    "customer-detail",
    "CRM 360°",
    "Lịch sử đơn, AOV, tag, nhân viên phụ trách và ghi chú chăm sóc.",
    peopleRows
  )
};

export const getAdminModule = (id = "dashboard") =>
  adminModules[id] ?? adminModules.dashboard;
